// Libraries
import React from "react";

// Dependencies
import "./styles.css";

const ErrorPage = () => {
  return (
    <div>
      <img
        src="https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569_1280.jpg"
        alt="Page Not Found"
        className="err"
      />
    </div>
  );
};

export default ErrorPage;
